<template>
  <div class="upload-widget">
    <div v-show="$refs.upload && $refs.upload.dropActive"
        class="drop-active">
        <!-- overlay on active drop action -->
      <h3>Drop a file to upload</h3>
    </div>
    <div class="dropbox text-center p-4">
      <h4>Drop files anywhere to upload</h4>
      <!-- <label for="file" class="btn btn-lg btn-primary">Select Files</label> -->
    </div>

    <div class="dropinstruction text-center py-1">
      or<br />
    </div>

    <div class="upload text-center pb-4">
      <file-upload
        class="btn btn-primary"
        :post-action="uploadURL"
        extensions="gif,jpg,jpeg,png,bmp,tif,tiff,webp"
        accept="image/png,image/gif,image/jpeg,image/bmp,image/tiff,image/webp"
        :multiple="false"
        :drop="true"
        :drop-directory="false"
        v-model="files"
        @input="inputUpdate"
        ref="upload">
        <i class="fa fa-plus"></i>
        <b-icon-folder aria-hidden="true"></b-icon-folder>
        Choose a file
      </file-upload>
      <div class="imagetypes pt-1">JPEG, GIF, PNG, WEBP, BMP, or TIF</div>
    </div>
    <div class="activate">
      <!-- <b-button variant=""
              v-if="!$refs.upload || !$refs.upload.active"
              @click.prevent="$refs.upload.active = true">
        Start Upload
      </b-button> -->

      <div class="fileinfo pl-2 text-center">
        <div v-if="file" :key="file.name">
          <div id="filedata">
            <span>{{ file.name }}</span> -
            <span>{{ file.size | formatSize }}</span>
          </div>
          <div class="uploadstatus pb-2">
            <b-progress max="100">
              <b-progress-bar
                  v-if="!file.success"
                  :value="file.progress"
                  :label="progressLabel"
                  :show-progress="!file.success"
                  :animated="!file.success"
              ></b-progress-bar>
            </b-progress>

            <button type="button" class="btn btn-danger m-2" size="sm"
                    v-if="$refs.upload && $refs.upload.active"
                    @click.prevent="$refs.upload.active = false">
              <i class="fa fa-stop" aria-hidden="true"></i>
              Stop
            </button>
            <span v-if="file.error">Error: {{file.error}} </span>
            <!-- <span v-else-if="file.active">Uploading...</span> -->
            <!-- <span v-else-if="file.success">success</span> -->
          </div>
        </div>
        <div v-if="!file">
          <!-- <em>No file</em> -->
        </div>
      </div>

      <div class="imagepreview text-center">
        <img class="thumbnail"
             v-if="file && file.response && file.response.imagepath"
             :src="file.response.imagepath"
             alt="uploaded image" />
         <img class="thumbnail"
              v-else
              src="@/assets/placeholder.png"
              alt="placeholder" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import axios from 'axios';
import { BIconFolder } from 'bootstrap-vue';

import FileUpload from 'vue-upload-component';

export default {
  name: 'ImageUpload',
  components: {
    FileUpload,
    BIconFolder,
  },
  data() {
    return {
      files: [],
      uploadURL: '',
      fileURL: '',
    };
  },
  props: {
    idx: Number,
  },
  computed: {
    file() {
      let f;
      if (this.files) {
        [f] = this.files;
      }
      return f;
    },
    progressLabel() {
      let label = Math.round(this.file.progress);
      if (this.file.success) {
        label = '';
      } else if (label === 100) {
        label = 'processing';
      }
      return label.toString();
    },
    ...mapState(['config', 'imageToSelect']),
  },
  methods: {
    newUploadURL() {
      console.log(this.config.imageUploadURLGenerator);
      axios.get(this.config.imageUploadURLGenerator)
        .then((response) => {
          this.uploadURL = response.data;
          console.log('uploadURL', this.uploadURL);
        })
        .catch((error) => {
          console.log(error);
          this.$bvToast.toast(
            'Network error; image upload may not work. Please reload page to try again.',
            {
              title: 'Network Error',
              toaster: 'b-toaster-top-center',
              variant: 'danger',
              solid: true,
              noAutoHide: true,
            },
          );
        });
    },
    inputUpdate(files) {
      // console.log('inputUpdate', files);
      if (files.length > 0) {
        const f = files[0];
        // console.log('f', f);
        // when a file is selected, start upload immediately
        if (f.name && !(f.active || f.error || f.success) && !this.$refs.upload.active) {
          this.$store.commit('clearImageToSelect', this.idx); // this tab's selected image gets cleared
          this.$refs.upload.active = true; // start upload
        }
        // when upload complete, set image
        if (f.success && f.response) {
          const img = { key: f.response.imagekey, path: f.response.imagepath };
          this.$store.commit('setImageToSelect', { image: img, bucket: this.idx });
          this.uploadURL = '';
          this.newUploadURL();
        }
      }
    },
  },
  created() {
    this.newUploadURL();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* label.btn {
  margin-bottom: 0;
  margin-right: 1rem;
} */

.dropbox {
  border: thin silver dashed;
}

.upload {
}

.imagetypes {
  font-size: x-small;
}

.fileinfo {
  vertical-align: text-top;
}

.drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: .6;
  text-align: center;
  background: #000;
}
.drop-active h3 {
  margin: -.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}

.imagepreview .thumbnail {
  height: 20vh;
}

@media (hover: none) {
   /* catch mobile devices to remove drag and drop target */
   .dropbox, .dropinstruction {
     display: none;
   }
}
</style>
